/* @flow */

import { rem } from 'polished';

import { fadeDuration } from '@e180/ui/lib/token/animation';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',

    width: '100%',
    height: '100%',
    padding: '8px 8px 24px',

    transition: `opacity ${fadeDuration}`,
  },

  'root-isHidden': {
    opacity: 0,
  },

  top: {
    width: '100%',
  },

  heading: {
    maxWidth: 240,
    margin: '8px auto 32px',
  },

  meeting: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    maxWidth: 300,
    marginBottom: 48,
    padding: 8,
  },

  icon: {
    minHeight: 72,
    height: 'auto',
    width: 72,
    marginRight: 12,
  },

  instructions: {
    margin: '0',

    fontSize: rem(18, baseFontSize),
    lineHeight: 26 / 18,
    WebkitFontSmoothing: 'antialiased',
  },
};
